/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */


export function init() {
        // Scoped to the map, not the document. Cancelling every multi-touch
        // gesture page-wide also cancelled the browser's own pinch-zoom, so
        // the page could not be enlarged at all on a touch device. Inside the
        // map the gesture belongs to the map's own pan and zoom; everywhere
        // else -- popups, articles, the page chrome -- it belongs to the
        // browser.
        const mapElem = document.getElementById('map');
        if (!mapElem) {
            return;
        }
        const preventMultiTouch = (e) => {
            const t = e.touches ?? e.changedTouches ?? [];
            if (t.length > 1) e.preventDefault();
        };
        mapElem.addEventListener('touchstart', preventMultiTouch, {
            passive: false
        });
        mapElem.addEventListener('touchmove', preventMultiTouch, {
            passive: false
        });
}
